export const ASPECT_RATIO_16_9 = 16 / 9;
export const ASPECT_RATIO_9_16 = 9 / 16;

export function getSize(screenSizeRatio) {
  return screenSizeRatio < ASPECT_RATIO_16_9
    ? ["100vw", "56.25vw"]
    : ["174.22vh", "98vh"];
}

export function getViewSize(screenSizeRatio) {
  return screenSizeRatio < ASPECT_RATIO_16_9
    ? [(99 * window.innerWidth) / 100, (55.69 * window.innerWidth) / 100]
    : [(174.22 * window.innerHeight) / 100, (98 * window.innerHeight) / 100];
}

export function setScreenType(isPortrait, isLandscape, setSize, setViewSize) {
  const ratio = window.innerWidth / window.innerHeight;
  if (isPortrait) {
    setSize(
      ratio < ASPECT_RATIO_9_16
        ? [`${window.innerWidth}px`, `${window.innerWidth * 1.7777}px`]
        : [`${window.innerHeight * 0.5625}px`, `${window.innerHeight}px`]
    );
    setViewSize(
      ratio < ASPECT_RATIO_9_16
        ? [window.innerWidth, 1.7777 * window.innerWidth]
        : [0.5625 * window.innerHeight, window.innerHeight]
    );
  } else if (isLandscape) {
    setSize(
      ratio < ASPECT_RATIO_16_9
        ? [`${window.innerWidth}px`, `${window.innerWidth * 0.5625}px`]
        : [`${window.innerHeight * 1.7777}px`, `${window.innerHeight}px`]
    );
    setViewSize(
      ratio < ASPECT_RATIO_16_9
        ? [window.innerWidth, window.innerWidth * 0.5625]
        : [window.innerHeight * 1.7777, window.innerHeight]
    );
  } else {
    setSize(getSize(ratio));
    setViewSize(getViewSize(ratio));
  }
}

export function getScreenWidth(screenRatio) {
  return screenRatio < ASPECT_RATIO_16_9
    ? (99 * window.innerWidth) / 100
    : (174.22 * window.innerHeight) / 100;
}

export function getScreenHeight(screenRatio) {
  return screenRatio < ASPECT_RATIO_16_9
    ? (55.69 * window.innerWidth) / 100
    : (99 * window.innerHeight) / 100;
}

export function isMobileTouchDevice() {
  return window.matchMedia("(pointer: coarse)").matches;
}

export function isPortraitMobile() {
  return (
    window.innerWidth < window.innerHeight &&
    isMobileTouchDevice()
  );
}

export function isLandscapeMobile() {
  return (
    window.innerWidth > window.innerHeight &&
    isMobileTouchDevice() &&
    window.innerWidth < 1024
  );
}

export function isTablet() {
  const width = window.innerWidth;
  return (
    window.innerWidth < window.innerHeight &&
    width >= 600 &&
    width <= 1366 &&
    isMobileTouchDevice()
  );
}

// True when the player page is shown inside an <iframe> (or forced via ?embed).
// Used so orientation/device detection keys off the iframe's own dimensions
// rather than the visitor's physical screen/touch, which inside a cross-origin
// iframe report the PARENT page's context (e.g. a landscape desktop monitor),
// causing the player to take the wrong layout path.
export function isEmbedded() {
  if (typeof window === "undefined") return false;
  if (window.self !== window.top) return true;
  try {
    return new URLSearchParams(window.location.search).has("embed");
  } catch (e) {
    return false;
  }
}
